import React from "react";
import { Container } from 'reactstrap';
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import ProfileAllScrappedDataCard from "./ProfileAllScrappedDataCard";
import ProfileAllScrappedDataLoader from './ProfileAllScrappedDataLoader';

const heights = {
  age: 600,
  price: 430,
  target_group: 430,
  style: 430,
  market: 370,
  product_category: 600,
};

const titles = {
  age: "Age Group",
  price: "Price Range",
  target_group: "Target Group",
  style: "Product Style",
  market: "Preferred Market",
  product_category: "Category",
  eco_friendly: "Eco Friendly",
  size: "Size",
  brand_awareness: "Brand Awarness",
  ecom_rating: "Ecom Rating",
  pos_rating: "POS Rating",
  market_diversity: "Market Diversity",
};

const ProfileAllScrappedData = ({ allScrappedData, isLoading }) => {
  const isAllFieldsEmpty = Object.values(allScrappedData).filter(v => v?.length !== 0)?.length;

  if (!isLoading && isAllFieldsEmpty <= 0) {
    return (
      <Container
        fluid
        className="d-flex flex-column justify-content-center align-items-center text-center py-5"
      >
        <h6
          className="mb-1 text-black"
          style={{
            fontSize: '22px',
            fontWeight: 600,
          }}
        >
          We are getting useful insights
        </h6>
        <p
          className="text-muted"
          style={{
            fontSize: '16px',
            fontWeight: 500,
          }}
        >
          AI engine is working and grabbing exciting data
        </p>
        <img
          src='/loader.gif'
          alt="Loading"
          className="img-fluid"
          style={{ height: '200px' }}
        />
      </Container>
    );
  }

  return (
    <div className="p-2">
      {isLoading ? (
        <div
          className="mb-2 bg-light"
          style={{
            height: '30px',
            width: '250px',
            animation: 'pulse 1.5s infinite'
          }}
        />
      ) : (
        <h4
          className="mb-2"
          style={{
            fontSize: '20px',
            fontWeight: 500,
          }}
        >
          Data Categories Based On
        </h4>
      )}

      <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3 }}>
        <Masonry columnsCount={3} gutter="25px">
          {isLoading && ['age', 'price', 'target_group', 'style', 'market', 'product_category'].map((key) => (
            <ProfileAllScrappedDataLoader
              key={key}
              height={heights[key]}
            />
          ))}

          {!isLoading && Object.keys(allScrappedData).map((key) => (
            <ProfileAllScrappedDataCard
              key={key}
              title={titles[key]}
              data={allScrappedData[key]}
              height={heights[key]}
            />
          ))}
        </Masonry>
      </ResponsiveMasonry>
    </div>
  );
};

export default ProfileAllScrappedData;